<template>
    <div class="Details">
      
      <div class="columns">
          
          <div class="column">
              
       <section ref="element">
       
          <div class="x">
             <div class="box" v-if="!project.datasetId && !project.modelId">
                <h4 class="title is-4">Upload a dataset and run your AI model training</h4>
             </div>
             <div class="box" v-else-if="false && project.datasetId && documents && (!project.model_metrics || 'model_metrics' in project || project.model_metrics['accuracy'] < 0.8)">
              <b-image
                         class="is-pulled-right"
                         style="width: 23em"
                         :src="require('@/images/training-example.svg')">
                      </b-image>
                <h4 class="title is-4">
                  Data Annotation for Continuous Improvement of AI Models
              </h4>
              
              <p class="subtitle is-5">
                  To train an AI model to classify data accurately, we need to annotate a few data points that represent the different classes we want the model to learn. By labeling these data points with their respective class, we can help the model learn the patterns and features associated with each class, allowing it to make accurate predictions when given new, unseen data.
              </p>
              
             </div>
  
             <b-skeleton size="is-large" height="80px" :active="!documents"></b-skeleton>
             <b-skeleton size="is-large" height="160px" :active="!documents"></b-skeleton>
             <div class="box" v-if="documents">
              <b-field>
                   <p class="control has-icons-left">
                      <input expanded @input="changeFilter"
                         v-model="search"
                         style="min-width: 20em"
                         class="input" type="text" placeholder="Introduce a text query">
                         
                      <span class="icon is-left">
                      <i class="fas fa-search" aria-hidden="true"></i>
                      </span>
                   </p>
                   
                </b-field>
                
                <Annotation />
                
                 <!-- <b-field grouped group-multiline>
                   
                   <b-field label="Add Sample">
                      <b-button expanded @click="" type="is-info is-light">Add text</b-button>
                   </b-field>
                   <b-input v-model="pageInput"></b-input>
                </b-field> -->
                
                <hr>
                
                <b-table 
                   :data="documents"
                   :per-page="annotationMode?1:30"
                   :current-page.sync="currentPage"
                   :total="documents.length"
                   :pagination-position="annotationMode?'bottom':'both'"
                   paginated
                   pagination-size="is-small"
                   :loading="!documents || isLoading"
                   >
                   <template #top-left>
                          <b>Records</b>: {{ documents.length }}
                    </template>
                    
                    <b-table-column width="100" field="text" label="" v-slot="props">
                      <div class="box">
                         <div class="">
                            <div class="columns">
                               <div class="column is-12">
                                  <!-- controls -->
                                  <div class="buttons is-pulled-right">
                                      <b-dropdown :triggers="['hover', 'click']" 
                                      position="is-bottom-left"
                                      aria-role="list"
                                      >
                                          <template #trigger>
                                              <i class="fa fa-bars" aria-hidden="true"></i>
                                          </template>
                                          <b-dropdown-item aria-role="listitem" @click="deleteDocument(props.row)">
                                              <i class="fa fa-times" aria-hidden="true"></i> Delete record
                                          </b-dropdown-item>
                                          <b-dropdown-item aria-role="listitem" disabled>
                                              <i class="fa fa-search" aria-hidden="true"></i> Find similar
                                          </b-dropdown-item>
                                          <b-dropdown-item aria-role="listitem" disabled>
                                              <i class="fa fa-plus" aria-hidden="true"></i> Generate similar
                                          </b-dropdown-item>
                                      </b-dropdown>
                                      </div>
                                  <div>
                                   <b-tag 
                                   style="bottom:0.3em;margin-right: 0.2em;" 
                                   size="is-small" type="is-light">Text
                                   </b-tag>
                                   <b-field>
                                    <b-input v-model="props.row.text" @input="changeInput(props.row)" maxlength="1000" type="textarea" ></b-input>
                                   </b-field>
                                  </div>
                                  <div v-if="project.type == 'generation'">
                                   <b-tag 
                                   style="bottom:0.3em;margin-right: 0.2em;"
                                   size="is-small" type="is-light">Completion
                                   </b-tag>
                                   <b-field>
                                    <b-input v-model="props.row.label" @input="changeOutput(props.row)" rows=2 maxlength="500" type="textarea" ></b-input>
                                   </b-field>
                                  </div>
                                  <div class="" style="margin-top:1em;margin-bottom: 0.5em;">
                                     
                                    <!-- prediction-->
                                      
                                     <b-taglist attached v-if="!props.row.prediction===false">
                                        
                                        <b-tag style="bottom:0.25em;margin-right: 1em;" size="is-small" type="is-light">
                                                     Prediction
                                        </b-tag>
                                        <div style="margin-right: 0.2em;">
                                        <b-tag size="is-smallx" v-if="props.row.prediction===props.row.label && props.row.label!==false" type="is-success">👍</b-tag>
                                        <b-tag size="is-smallx" v-else-if="props.row.prediction!=props.row.label && props.row.label===false" type="is-light">❓</b-tag>
                                        <b-tag size="is-smallx" v-else-if="props.row.prediction!=props.row.label && props.row.label!==false" type="is-danger">👎</b-tag>
                                        <b-tag size="is-smallx" v-else></b-tag>
                                        </div>
                                        <b-tooltip type="is-dark is-light" position="is-bottom" multilined>
                                           <b-tag size="is-smallx" v-if="props.row.prediction!==false" type="is-ligth">
                                              {{ props.row.prediction }} 
                                              <span v-if="props.row.confidence">
                                              ({{ (props.row.confidence*100).toFixed(2) }}%)
                                              </span>
                                           </b-tag>
                                           <template v-slot:content v-if="props.row.prediction==props.row.label" >
                                              <b>Predicted correctlly</b>.<br>
                                              Obtained the predicted label and confidence score using the Cross Validation method Leave One Out.
                                           </template>
                                           <template v-slot:content v-else-if="props.row.prediction==false" >
                                              AI model are going to predict or you need to retrain the model to predict this one document.
                                           </template>
                                           <template v-slot:content v-else-if="props.row.prediction!=props.row.label && props.row.label==false" >
                                              Predicted by the AI model, but you need to label the document to accurate the model prediction.
                                           </template>
                                           <template v-slot:content v-else-if="props.row.prediction!=props.row.label && props.row.label!=false" >
                                              <b>Predicted wrongly</b>.<br>
                                              You can analyze the wrong predictions and check if it needed to add more data for a specific label.
                                           </template>
                                        </b-tooltip>
                                        
                                     </b-taglist>
                                     
                                           
                                        
                                     
                                      <p style="bottom:0;margin-bottom: -1em;color: gray">
                                          <small><small>
                                              <!-- <p>{{  props.row.metadata }}</p> -->
                                              Record card: {{  props.row.id }}
                                              <!-- iterate metadata object -->
                                              <span v-if="isJsonString(props.row.metadata)">
                                                <span v-for="k,v in JSON.parse(props.row.metadata)" :key="k">
                                                    <span>{{ v }}</span>: {{  k }}
                                                </span>
                                              </span>
                                          </small></small>
                                          <small><small>
                                          </small></small>
                                      </p>
                                   </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      
                      
                    </b-table-column>
                    <!-- Annotation mode controls -->
                    <template #footer v-if="annotationMode">
                      <div class="buttons is-centered">
                          
                          <b-button type="is-primary" @click="nextPage()">
                              Continue
                              <span class="labelCode">
                                  Press C
                              </span>
                          </b-button>
                      </div>
                    </template>
                   <template #bottom-left v-if="annotationMode">
                          <b>Annotated records: {{ documents.filter( i => i.label !== null).length }} out of {{ documents.length }}</b>
                   </template>
                    
                </b-table>
                <hr>
             </div>
          </div>
       </section>
       
          </div>
      </div>
  
       <b-modal
            v-model="isModalLabelsOpen"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Model"
            aria-modal
            scroll="keep">
            <template #default="props">
              <ModalLabels @close="props.close" :labelingMode="true" :project="project" :projectDocuments="projectDocuments"></ModalLabels>
            </template>
        </b-modal>
  
    </div>
  </template>
  <script>
    import TrainModel from '@/components/TrainModel.vue'
    import TrainRuns from '@/components/TrainRuns.vue'
    import ModalLabels from '@/components/ModalLabels.vue'
    // import Annotation from '@/components/AnnotationTemplate.vue'
    import Annotation from '@/components/AnnotationTemplateNER.vue'
    import fuzzysort from 'fuzzysort'
    import { mapState } from 'vuex';
  import { timeout } from 'q'
  
    export default {
         props: ["project", "projectModels", "projectDatasets", "currentUser"],
         name: "Train",
         data: function() {
        return {
            perPage: 10,
            currentPage: 1,
            pageInput: 1,
            annotationMode: this.project.annotationMode || false,
            isMounting: true,
            checkedRows: [],
            isModalLabelsOpen: false,
            viewFilter: (this.$route.query.f == 'errors')?'issues':'all',
            viewOptions: ['all', 'labeled', 'unlabeled', 'issues'],
            versions: false,
            checkboxCustom: [],
            selected: {text: false, label: 'unlabeled'},
            newLabel: false,
            selectedVersion: 'v1',
            animated: true,
            candidateLabels: [(1,1),(2,3)],
            isModalTrainCreateOpen: false,
            labelKeys: [],
            options: {
            
            },
            total: 0,
            predicted: 'any',
            given: 'any',
            search: null,
            sortBy: null,
            filterByDataset: 'any',
            uploadList: [],
            labelsViewMin: 8
        }},
        components: {
          "modal-train": TrainModel,
          "train-runs": TrainRuns,
          ModalLabels,
          Annotation
        },
        computed: {
          metrics() {
                  return this.$store.getters.progressMetrics(this.project.datasetId)
          },
          isLoading(){
              return this.$store.getters.isLoading
          },
         rows() {
              return this.$store.getters.rowsByDataset(this.project.datasetId)
         },
         documents() {
          return this.sortDocuments(
                this.fuzzySearchFilter(
                  this.$store.getters.rowsByDataset(this.project.datasetId).filter( 
                    item => (
                      this.givenFilter(item) && this.predictedFilter(item) && this.searchFilter(item) && this.datasetFilter(item)
                    )
                  )
                )
              )
          } 
         },
         filters: {
          dateFormat: function (value) {
              // from timestamp to date
              // parse to int
              value = parseInt(value)
              return new Date(value).toLocaleString('en-US', 
              { timeZone: 'UTC', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
          }
         },
         watch: {
          annotationMode: function(){
            if (this.annotationMode){
              this.given = 'any'
              this.$store.dispatch('getRowsByDatasetForAnnotation', this.project.datasetId).then(() => {
                  this.currentPage = 1
              })
            } else {
              this.$store.dispatch('getRowsByDataset', this.project.datasetId).then(() => {
                  this.currentPage = 1
              })
            }
            this.$store.dispatch("updateProject",
                      {projectId: this.project.id, 
                          update: {annotationMode: this.annotationMode}}
            )
          }
         },
         methods: {
            isJsonString(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
          },
          nextPage(){
              let totalRows = this.rows.length
              this.currentPage = this.currentPage + 1
              console.log(this.currentPage, totalRows)
              
              if (this.currentPage > totalRows || this.currentPage > 5){
                  console.log("realoading")
                  this.$store.commit('setLoading', true)
                  this.$store.dispatch('getRowsByDatasetForAnnotation', this.project.datasetId).then(() => {
                      this.currentPage = 1
                      setTimeout(() => {
                          this.$store.commit('setLoading', false)
                      }, 2000)
                  })
              }
          },
          enableAnnotationMode(){
              //this.$store.dispatch('getRowsByDatasetForAnnotation', this.project.datasetId)
          },
          triggerTraining(){
              this.$store.dispatch("triggerTraining",
                      {projectId: this.project.id}
              )
          },
          deleteDocument(row){
            let rowId = row.id
            this.$store.dispatch('deleteRow', row.id)
  
            this.rows = this.$store.getters.removeRow(rowId)
            this.triggerTraining()
            
          },
          checkLabelDist(){
            let labelsOk = 0
            for (label of this.project.labels){
              if(this.projectDocuments.filter( item => item.label == label.label).length >= 10){
                labelsOk += 1
              }
            }
            
            if (labelsOk == this.project.labels.length){
              console.log("ok")
            }
          },
          changeInput(row){
            
            const rowToUpdate = {
                datasetId: this.project.datasetId,
                createdAt: row.createdAt,
                id: row.id,
                text: row.text
            }
            
            this.$store.dispatch('updateRow', rowToUpdate)
            // this.triggerTraining()
        },changeOutput(row){
            
              const rowToUpdate = {
                  datasetId: this.project.datasetId,
                  createdAt: row.createdAt,
                  id: row.id,
                  label: row.label
              }
    
              // must have datasetId, text (or label)
              this.$store.dispatch('updateRow', rowToUpdate)
            //   this.triggerTraining()
          },
          changeFilter(){
              //   this.documents = this.getDocuments()
          },
          getLabels(){
            return (this.project.labels?this.project.labels:[])
          },
          predictedFilter(item){
            
            if (this.predicted == 'not'){
              return item.prediction == undefined || item.prediction === false || item.prediction == null || item.prediction == NaN
            } else if (this.predicted == 'agrees'){
              return item.prediction === item.label && item.label !== null && (item.prediction != undefined && item.prediction !== false && item.prediction != null)
            } else if (this.predicted == 'disagrees'){
              return item.prediction != item.label && item.label !== null && (item.prediction != undefined && item.prediction !== false && item.prediction != null)
            }  else if (this.predicted != 'any'){
              return item.prediction === this.predicted
            } else if (this.predicted == 'any'){
              return true
            } else {
              return false
            }
          },
          givenFilter(item){
            
            if (this.given === 'unlabeled'){
              return item.label === false || item.label == null || item.label === 'False' || item.label === undefined
            } else if (this.given != 'any'){
              return item.label === this.given
            } else if (this.given === 'any'){
              return true
            } else {
              return false
            }
          },
          searchFilter(item){
            return true;
            if (this.search != null){
              return item.text.toLowerCase().includes(this.search.toLowerCase())
            } else {
              return true
            }
          },
          fuzzySearchFilter(docs){
             const options = {
                 key: 'text',
                 limit: 100, // don't return more results than you need!
                 threshold: -10000, // don't return bad results
              }
              if (this.search != null && this.search != ""){
                 return fuzzysort.go(this.search, docs, options).flatMap(r => r.obj);
              } else {
                 return docs
              }
          },
          datasetFilter(item){
            if (this.filterByDataset !== 'any'){
              return item.uploadId === this.filterByDataset
            } else {
              return true
            }
          },
          sortDocuments(doc){
            if (this.sortBy == 'high_score'){
              return doc.sort((a,b) => b.confidence - a.confidence);
            } else if (this.sortBy == 'low_score'){
              return doc.sort((a,b) => a.confidence - b.confidence);
            } else {
              return doc
            }
          },
         },
          mounted() {
              console.log("isLoading", this.isLoading)
              this.isMounting = false
  
              if (this.annotationMode){
                  this.given = 'any'
                  this.$store.dispatch('getRowsByDatasetForAnnotation', this.project.datasetId)
              }
  
            //   window.addEventListener("keypress", e => {
            //       if (e.code == 'KeyC'){
            //           this.nextPage()
            //       }
            //   });
  
         }, created() {
  
         }
       };
  </script>
  <style lang="scss" scoped>
  
  .vertical {
    height: 500px;/*Altura da linha*/
    border-left: 2px solid;/* Adiciona borda esquerda na div como ser fosse uma linha.*/
  }
    .boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
    .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;
    &:hover {
    background: #fafafa;
    }
    .info {
    padding: 16px;
    .name {
    display: block;
    margin-bottom: 8px;
    text-transform: capitalize;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    }
    .description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0;
    margin-bottom: 8px;
    overflow: hidden;
    }
    }
    }
    }
  
  
  .labelCode {
    position: absolute; /* Set the span's position to absolute */
    bottom: 0; /* Align the span to the bottom */
    left: 50%; /* Align the span horizontally */
    transform: translateX(-50%); /* Center the span horizontally */
    font-size: 9px; /* Set the font size of the span */
  }
  
  
  
  
  </style>